import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
Vue.use(ElementUI);
import VueRouter from 'vue-router'
import router from './router' // 导入路由配置文件
// 注册路由插件
Vue.use(VueRouter)

new Vue({
    router, // 注入路由实例，否则组件中无法访问 this.$router
    render: h => h(App),
}).$mount('#app')
